import formatErrors from '../../../functions/formatErrors';
// Types
import { PayloadAction, createAction, createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { ErrorKeys } from '../../../functions/errorKeys';
import { Picture } from '../../picture/objects/picture';
import { Preferences } from '../../profile/objects/preferences';
import { Trip } from '../../trip/objects/trip';
import { EMPTY_ORGANISATION_CONTACT, EMPTY_ORGANISATION_RUBRICS_CONFIGURATION, EMPTY_TRIP_LIST_CONFIGURATION, EMPTY_TRIP_LIST_CRITERIA, ORGANISATION_COLUMNS, ORGANISATION_RUBRICS_MODULE, ORGANISATION_TRIP_MODULE } from '../constants/organisation.constants';
import { DeleteItem } from '../objects/deteItem';
import { Domain } from '../objects/domain';
import { OrganisationEditStep } from '../objects/editStep';
import { Errors } from '../objects/errors';
import { GroupMinimal } from '../objects/groupMinimal';
import { List } from '../objects/list';
import { MailHistory } from '../objects/mailHistory';
import { Network } from '../objects/network';
import { Organisation } from '../objects/organisation';
import { OrganisationComment } from '../objects/organisationComment';
import { OrganisationContact } from '../objects/organisationContact';
import { OrganisationContactErrors } from '../objects/organisationContactErrors';
import { OrganisationInvoice } from '../objects/organisationInvoice';
import { OrganisationNote } from '../objects/organisationNote';
import { OrganisationRubricsItemInterface } from '../objects/organisationRubricsItemInterface';
import { BillingMethod, OrganisationState, PreferredPaymentChoices } from '../objects/organisationState';
import { OrganisationTripListCriteria } from '../objects/organisationTripListCriteria';
import { setOrganisationRubricPreference } from '../utils/setOrganisationRubricPreference';
import { setOrganisationTripListPreference } from '../utils/setOrganisationTripListPreference';
import { Settlement } from '../../settlement/objects/settlement';
import { OrganisationHistTrip } from '../objects/organisationHistTrip';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Locale } from '../../locale/objects/locale';
import { RevisionHistory } from '../objects/organisationRevisionHistory';
import { EMPTY_ORGANISATION_MARGIN_LIST_CONFIGURATION, EMPTY_ORGANISATION_MARGIN_LIST_CRITERIA } from '../constants/marginConstants';
import { Margin } from '../../margin/objects/margin';
import { MarginListCriteria } from '../objects/marginListCriteria';
import { CentralPayment } from '../../centralPayment/objects/centralPayment';
import { Commercial } from '../../commercial/objects/commercial';
import { Column } from '../objects/column';


const subDomain = window.location.host.split('.')[0];
export const setPreferences = createAction<Preferences[]>('PROFILE_SET_PREFERENCES');

const EMPTY_ORGANISATION_FILTERS = {
    filter_creator: '',
    filter_last_author: '',
    filter_brands: [],
    filter_vat_number: '',
    filter_external_id: '',
    filter_city: '',
    filter_commercials: []
}

const initialState: OrganisationState = {
    address: '',
    longitude: '',
    latitude: '',
    google_id: '',
    zoom: 4,
    city: '',
    branch_code: null,
    is_organisation_location_edit_open: false,
    allow_margin: false,
    allow_margin_error: '',
    columns: ORGANISATION_COLUMNS,
    complementary_address: '',
    count: 0,
    country: null,
    create: false,
    created_date: null,
    creator: null,
    delay_payment: '',
    delay_payment_error: '',
    delete_organisation: null,
    domain: null,
    edit_step: OrganisationEditStep.ACTIVITY,
    edit_info: false,
    email: '',
    editing_field: '',
    email_error: '',
    phone_number_error: '',
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    ...EMPTY_ORGANISATION_FILTERS,
    filter_open: false,
    id: null,
    last_author: null,
    limit: 50,
    list: null,
    logo: null,
    logo_error: '',
    logo_progress: 0,
    modified_date: null,
    name: '',
    name_error: '',
    corporate_name_of_agency_error: '',
    group: null,
    sub_net: null,
    mini_network: null,
    group_error: '',
    group_paying: false,
    group_paying_error: '',
    order: 'asc',
    order_by: 'name',
    organisation: null,
    page: 0,
    phone_number: '',
    quota: 0,
    quota_error: '',
    refresh: false,
    running: false,
    search: '',
    siret: '',
    street: '',
    type: 2,
    type_error: '',
    vat_number: '',
    tier_code: '',
    zip_code: null,
    zip_code_error: '',
    paiement_delay: '',
    paiement_delay_error: '',
    postal_code: '',
    postal_code_error: '',
    notes: [],
    notes_loading: false,
    comments: [],
    comments_loading: false,
    contacts_create: [],
    contacts: [],
    contacts_loading: false,
    delete_item: null,
    external_id: '',
    is_blocked: false,
    is_active: true,
    internal_note: '',
    usual_name: '',
    commercials: [],
    account: '',
    allow_mailing: false,
    allow_phoning: false,
    allow_emailing: false,
    allow_smsing: false,
    unsubscribe_from_newsletter: false,
    orchestra_id: '',
    rubrics_configuration: EMPTY_ORGANISATION_RUBRICS_CONFIGURATION,
    email_loading: false,
    hist_trips: [],
    hist_trips_loading: false,
    trip_list: [],
    trip_list_configuration: EMPTY_TRIP_LIST_CONFIGURATION,
    trip_list_loading: false,
    trip_list_count: 0,
    trip_list_criteria: EMPTY_TRIP_LIST_CRITERIA,
    central_payment: null,
    due_date: null,
    due_date_error: '',
    origin_due_date: null,
    invoice_credential: null,
    invoice_list: null,
    trip_open_id: null,
    email_history: [],
    email_history_loading: false,

    activated_locales: [],
    contact_emails: [],
    phone_numbers: [],
    corporate_name_of_agency: '',
    Accounting_e_mails: [],
    preferred_payment_method: PreferredPaymentChoices.TRANSFER,
    billing_method: BillingMethod.MANUAL,
    third_party_account_number: '',
    revision_history: [],


    margins: [],
    margins_configuration: EMPTY_ORGANISATION_MARGIN_LIST_CONFIGURATION,
    margin: null,
    margins_loading: false,
    margins_count: 0,
    margins_criteria: EMPTY_ORGANISATION_MARGIN_LIST_CRITERIA,
    suspended_margin: null,
    refresh_margin_list: false,

    first_preference_loaded: false,

    brands: []
};


const refreshMarginListReducer = (state: OrganisationState): OrganisationState => ({
    ...state, refresh_margin_list: !state.refresh_margin_list
});

const setSuspendedMarginReducer = (state: OrganisationState, action: PayloadAction<Margin | null>): OrganisationState => ({
    ...state, suspended_margin: action.payload
});

const addMarginsConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, margins_configuration: { ...state.margins_configuration, preferences: [...state.margins_configuration.preferences, ...action.payload] }
});

const setMarginsConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, margins_configuration: { ...state.margins_configuration, preferences: action.payload }
});


const moveDownColumnMarginsReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.margins_configuration.columns]);
    for (let i = 0; i < columns.length; i++) {
        columns[i].last_updated = false;
    }
    const column = { ...columns[action.payload + 1] };
    columns[action.payload + 1] = columns[action.payload];
    columns[action.payload + 1].last_updated = true;
    columns[action.payload] = column;
    return { ...state, margins_configuration: { ...state.margins_configuration, columns } };
};


const moveUpColumnMarginsReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.margins_configuration.columns]);
    for (let i = 0; i < columns.length; i++) {
        columns[i].last_updated = false;
    }
    const column = { ...columns[action.payload - 1] };
    columns[action.payload - 1] = columns[action.payload];
    columns[action.payload - 1].last_updated = true;
    columns[action.payload] = column;
    return { ...state, margins_configuration: { ...state.margins_configuration, columns } };
};

const toggleColumnMarginsReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.margins_configuration.columns]);
    const column = { ...columns[action.payload] };
    column.checked = !column.checked;
    columns[action.payload] = column;
    return { ...state, margins_configuration: { ...state.margins_configuration, columns } };
};

const setNetworkMarginsReducer = (state: OrganisationState, action: PayloadAction<Margin[]>): OrganisationState => ({
    ...state, margins: action.payload
});
const updateMarginsCriteriaReducer = (state: OrganisationState, action: PayloadAction<MarginListCriteria>): OrganisationState => ({
    ...state, margins_criteria: action.payload
});
const updateMarginReducer = (state: OrganisationState, action: PayloadAction<Margin | null>): OrganisationState => ({
    ...state, margin: action.payload
});
const updateMarginsLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, margins_loading: action.payload
});
const updateMarginsCountReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, margins_count: action.payload
});

const setRevisionHistoryReducer = (state: OrganisationState, action: PayloadAction<RevisionHistory[]>): OrganisationState => ({
    ...state, revision_history: action.payload
});

const setActivatedLocalesReducer = (state: OrganisationState, action: PayloadAction<Locale[]>): OrganisationState => ({
    ...state, activated_locales: action.payload
});
const addContactEmailsReducer = (state: OrganisationState): OrganisationState => ({
    ...state, contact_emails: [...state.contact_emails, '']
});

const setContactEmailsReducer = (state: OrganisationState, action: PayloadAction<{ id: number, value: string }>): OrganisationState => ({
    ...state, contact_emails: state.contact_emails.map((email, index) => index === action.payload.id ? action.payload.value : email)
});

const deleteContactEmailsReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, contact_emails: state.contact_emails.filter((email, index) => index !== action.payload)
});

const addAccountingEmailsReducer = (state: OrganisationState): OrganisationState => ({
    ...state, Accounting_e_mails: [...state.Accounting_e_mails, '']
});

const setAccountingEmailsReducer = (state: OrganisationState, action: PayloadAction<{ id: number, value: string }>): OrganisationState => ({
    ...state, Accounting_e_mails: state.Accounting_e_mails.map((email, index) => index === action.payload.id ? action.payload.value : email)
});

const deleteAccountingEmailsReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, Accounting_e_mails: state.Accounting_e_mails.filter((email, index) => index !== action.payload)
});

const addPhoneNumbersReducer = (state: OrganisationState): OrganisationState => ({
    ...state, phone_numbers: [...state.phone_numbers, '']
});

const setPhoneNumbersReducer = (state: OrganisationState, action: PayloadAction<{ id: number, value: string }>): OrganisationState => ({
    ...state, phone_numbers: state.phone_numbers.map((phone_number, index) => index === action.payload.id ? action.payload.value : phone_number)
});

const deletePhoneNumbersReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, phone_numbers: state.phone_numbers.filter((phone_number, index) => index !== action.payload)
});

const setCorporateNameOfAgencyReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, corporate_name_of_agency: action.payload, corporate_name_of_agency_error: ''
});

const setPreferredPaymentMethodReducer = (state: OrganisationState, action: PayloadAction<PreferredPaymentChoices>): OrganisationState => ({
    ...state, preferred_payment_method: action.payload
});

const setBillingMethodReducer = (state: OrganisationState, action: PayloadAction<BillingMethod>): OrganisationState => ({
    ...state, billing_method: action.payload
});

const setColumnsReducer = (state: OrganisationState, action: PayloadAction<Column[]>): OrganisationState => ({
    ...state, columns: action.payload,
});

const setTripColumnsReducer = (state: OrganisationState, action: PayloadAction<Column[]>): OrganisationState => ({
    ...state, trip_list_configuration: { ...state.trip_list_configuration, columns: action.payload }
});

const resetOrganisationReducer = (state: OrganisationState): OrganisationState => ({
    ...state,
    organisation: null,
    create: false,
    name: '',
    name_error: '',
    corporate_name_of_agency_error: '',
    type: 2,
    email: '',
    email_error: '',
    phone_number_error: '',
    quota: 0,
    quota_error: '',
    vat_number: '',
    tier_code: '',
    phone_number: '',
    complementary_address: '',
    postal_code: '',
    postal_code_error: '',
    city: '',
    branch_code: null,
    is_organisation_location_edit_open: false,
    country: null,
    siret: '',
    paiement_delay: '',
    paiement_delay_error: '',
    group_paying: false,
    group_paying_error: '',
    allow_margin: false,
    allow_margin_error: '',
    domain: null,
    group: null,
    sub_net: null,
    mini_network: null,
    group_error: '',
    logo: null,
    logo_error: '',
    logo_progress: 0,
    edit_info: false,
    contacts_create: [],
    central_payment: null,
    due_date: null,
    due_date_error: '',
    origin_due_date: null,
    usual_name: '',
    commercials: [],
    account: '',
    allow_mailing: false,
    allow_phoning: false,
    allow_emailing: false,
    allow_smsing: false,
    unsubscribe_from_newsletter: false,
    street: '',
    address: '',
    longitude: '',
    latitude: '',
    google_id: '',
    zoom: 4,
    external_id: '',
    is_blocked: false,
    is_active: true,
    internal_note: '',
    contact_emails: [],
    activated_locales: [],
    phone_numbers: [],
    corporate_name_of_agency: '',
    Accounting_e_mails: [],
    preferred_payment_method: PreferredPaymentChoices.TRANSFER,
    billing_method: BillingMethod.MANUAL,
});
const resteProfilLogoReducer = (state: OrganisationState): OrganisationState => ({
    ...state, logo: null, logo_error: ''
});
const setDeleteOrganisationReducer = (state: OrganisationState, action: PayloadAction<any>): OrganisationState => {
    if (action.payload === null && state.delete_organisation) {
        const list = state.list ? [...state.list] : state.list;
        let count = state.count;
        if (list) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].id === state.delete_organisation.id) {
                    list.splice(i, 1);
                    count--;
                    break;
                }
            }
        }
        return { ...state, count: count, delete_organisation: action.payload, list: list };
    } else {
        return { ...state, delete_organisation: action.payload };
    }
};
const setEditStepReducer = (state: OrganisationState, action: PayloadAction<OrganisationEditStep>): OrganisationState => ({
    ...state, edit_step: action.payload
});
const setEditingFieldReducer = (state: OrganisationState, action: PayloadAction<keyof Organisation | '' | 'commercials'>): OrganisationState => ({
    ...state, editing_field: action.payload
});
const setErrorReducer = (state: OrganisationState, action: PayloadAction<{ field: ErrorKeys<OrganisationState>, value: string }>): OrganisationState => ({
    ...state, [action.payload.field]: action.payload.value
});
const setErrorsReducer = (state: OrganisationState, action: PayloadAction<Errors>): OrganisationState => ({
    ...state, name_error: action.payload.name ? Array.isArray(action.payload.name) ? formatErrors(action.payload.name) : action.payload.name : ''
});
const setExportTypeReducer = (state: OrganisationState, action: PayloadAction<'CSV' | 'PDF'>): OrganisationState => ({
    ...state, export_type: action.payload
});
const setLimitReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, list: null, limit: action.payload
});
const setListReducer = (state: OrganisationState, action: PayloadAction<List>): OrganisationState => ({
    ...state, count: action.payload.count, list: action.payload.results, running: false
});
const setLogoErrorReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, logo_progress: 0, logo_error: action.payload
});
const setOrderByReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc' : 'asc'
});
const setPageReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, list: null, page: action.payload
});
const setRunningReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, running: action.payload
});
const setSearchReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, list: null, search: action.payload, page: 0
});
const setOrganisationReducer = (state: OrganisationState, action: PayloadAction<Organisation>): OrganisationState => ({
    ...state,
    organisation: {
        ...action.payload,
        name: action.payload.name,
        contact_email: action.payload.contact_email,
        type: action.payload.type,
        quota: Number(action.payload.quota_users_bo) || 0,
        vat_number: action.payload.vat_number || '',
        tier_code: action.payload.tier_code || '',
        phone_number: action.payload.phone_number || '',
        address: action.payload.street || '',
        longitude: action.payload.longitude || '',
        latitude: action.payload.latitude || '',
        google_id: action.payload.google_id || '',
        zoom: action.payload.zoom || 4,
        complementary_address: action.payload.street2 || '',
        postal_code: action.payload.zip_code || '',
        city: action.payload.city || '',
        branch_code: action.payload.branch_code,
        country: action.payload.state ?? null,
        street: action.payload.street || '',
        siret: action.payload.siret || '',
        paiement_delay: action.payload.paiement_delay || '',
        group_paying: !!action.payload.group_paying,
        allow_margin: !!action.payload.allow_margin,
        domain: action.payload.domain,
        group: action.payload.group_minimal,
        sub_net: action.payload.sub_net,
        mini_network: action.payload.mini_network,
        logo: action.payload.logo,
        external_id: action.payload.external_id,
        is_blocked: action.payload.is_black_listed,
        is_active: action.payload.is_active,
        internal_note: action.payload.internal_note || '',
        usual_name: action.payload.usual_name || '',
        account: action.payload.account,
        third_party_account_number: action.payload.third_party_account_number,
        allow_mailing: action.payload.allow_mailing,
        allow_phoning: action.payload.allow_phoning,
        allow_emailing: action.payload.allow_emailing,
        allow_smsing: action.payload.allow_smsing,
        unsubscribe_from_newsletter: action.payload.unsubscribe_from_newsletter,
        orchestra_id: action.payload.orchestra_id,
        central_payment: action.payload.central_payment,
        due_date: action.payload.due_date,
        origin_due_date: action.payload.origin_due_date,
        activated_locales: action.payload.activated_locales ?? [],
        contact_emails: action.payload.contact_emails ?? [],
        phone_numbers: action.payload.phone_numbers ?? [],
        corporate_name_of_agency: action.payload.corporate_name_of_agency ?? '',
        Accounting_e_mails: action.payload.Accounting_e_mails ?? [],
        preferred_payment_method: action.payload.preferred_payment_method ?? PreferredPaymentChoices.TRANSFER,
        billing_method: action.payload.billing_method ?? BillingMethod.MANUAL,
        brands: action.payload.brands ?? []
    },
    name: action.payload.name,
    name_error: '',
    corporate_name_of_agency_error: '',
    type: action.payload.type,
    email: action.payload.contact_email,
    email_error: '',
    phone_number_error: '',
    quota: Number(action.payload.quota_users_bo) || 0,
    quota_error: '',
    vat_number: action.payload.vat_number || '',
    tier_code: action.payload.tier_code || '',
    phone_number: action.payload.phone_number || '',
    address: action.payload.street || '',
    longitude: action.payload.longitude || '',
    latitude: action.payload.latitude || '',
    google_id: action.payload.google_id || '',
    zoom: action.payload.zoom || 4,
    complementary_address: action.payload.street2 || '',
    postal_code: action.payload.zip_code || '',
    postal_code_error: '',
    city: action.payload.city || '',
    branch_code: action.payload.branch_code,
    country: action.payload.state ?? null,
    street: action.payload.street || '',
    siret: action.payload.siret || '',
    paiement_delay: action.payload.paiement_delay || '',
    paiement_delay_error: '',
    group_paying: !!action.payload.group_paying,
    group_paying_error: '',
    allow_margin: !!action.payload.allow_margin,
    allow_margin_error: '',
    group: action.payload.group_minimal,
    sub_net: action.payload.sub_net,
    mini_network: action.payload.mini_network,
    domain: action.payload.domain,
    group_error: '',
    logo: action.payload.logo,
    logo_error: '',
    logo_progress: 0,
    edit_step: OrganisationEditStep.ACTIVITY,
    edit_info: false,
    external_id: action.payload.external_id ?? '',
    is_blocked: action.payload.is_black_listed,
    is_active: action.payload.is_active,
    internal_note: action.payload.internal_note || '',
    usual_name: action.payload.usual_name || '',
    account: action.payload.account || '',
    third_party_account_number: action.payload.third_party_account_number || '',
    allow_mailing: !!action.payload.allow_mailing,
    allow_phoning: !!action.payload.allow_phoning,
    allow_emailing: !!action.payload.allow_emailing,
    allow_smsing: !!action.payload.allow_smsing,
    unsubscribe_from_newsletter: !!action.payload.unsubscribe_from_newsletter,
    orchestra_id: action.payload.orchestra_id || '',
    central_payment: action.payload.central_payment || null,
    due_date: action.payload.due_date || null,
    due_date_error: '',
    origin_due_date: action.payload.origin_due_date || null,

    activated_locales: action.payload.activated_locales ?? [],
    contact_emails: action.payload.contact_emails ?? [],
    phone_numbers: action.payload.phone_numbers ?? [],
    corporate_name_of_agency: action.payload.corporate_name_of_agency ?? '',
    Accounting_e_mails: action.payload.Accounting_e_mails ?? [],
    preferred_payment_method: action.payload.preferred_payment_method ?? PreferredPaymentChoices.TRANSFER,
    billing_method: action.payload.billing_method ?? BillingMethod.MANUAL,
});
const setTypeReducer = (state: OrganisationState, action: PayloadAction<1 | 2>): OrganisationState => ({
    ...state, type: action.payload
});
const toggleColumnReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = [...state.columns];
    const column = { ...columns[action.payload] };
    column.checked = !column.checked;
    columns[action.payload] = column;
    return { ...state, columns: columns };
};
const toggleAllowMarginReducer = (state: OrganisationState): OrganisationState => ({
    ...state, allow_margin: !state.allow_margin, allow_margin_error: ''
});
const toggleCreateReducer = (state: OrganisationState): OrganisationState => ({
    ...state, create: !state.create
});
const toggleExportReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, export_list: action.payload
});
const toggleExportFullReducer = (state: OrganisationState): OrganisationState => ({
    ...state, export_full: !state.export_full
});
const toggleFiltersReducer = (state: OrganisationState): OrganisationState => ({
    ...state, filter_open: !state.filter_open
});
const toggleEditInfoReducer = (state: OrganisationState): OrganisationState => ({
    ...state,
    edit_info: !state.edit_info,
    name: state.organisation?.name || '',
    name_error: '',
    corporate_name_of_agency_error: '',
    type: state.organisation?.type || 2,
    email: state.organisation?.contact_email || '',
    email_error: '',
    phone_number_error: '',
    quota: state.organisation?.quota || 0,
    quota_error: '',
    vat_number: state.organisation?.vat_number || '',
    tier_code: state.organisation?.tier_code || '',
    phone_number: state.organisation?.phone_number || '',
    address: state.organisation?.address || '',
    longitude: state.organisation?.longitude || '',
    latitude: state.organisation?.latitude || '',
    google_id: state.organisation?.google_id || '',
    zoom: state.organisation?.zoom || 4,
    complementary_address: state.organisation?.complementary_address || '',
    postal_code: state.organisation?.postal_code || '',
    postal_code_error: '',
    city: state.organisation?.city || '',
    branch_code: state.organisation?.branch_code || null,
    country: state.organisation?.country ?? null,
    street: state.organisation?.street || '',
    siret: state.organisation?.siret || '',
    paiement_delay: state.organisation?.paiement_delay || '',
    paiement_delay_error: '',
    group_paying: !!state.organisation?.group_paying,
    group_paying_error: '',
    allow_margin: !!state.organisation?.allow_margin,
    allow_margin_error: '',
    group: state.organisation?.group || null,
    sub_net: state.organisation?.sub_net || null,
    mini_network: state.organisation?.mini_network || null,
    domain: state.organisation?.domain || null,
    group_error: '',
    logo: state.organisation?.logo || null,
    logo_error: '',
    usual_name: state.organisation?.usual_name || '',
    account: state.organisation?.account || '',
    third_party_account_number: state.organisation?.third_party_account_number || '',
    allow_mailing: !!state.organisation?.allow_mailing,
    allow_phoning: !!state.organisation?.allow_phoning,
    allow_emailing: !!state.organisation?.allow_emailing,
    allow_smsing: !!state.organisation?.allow_smsing,
    unsubscribe_from_newsletter: !!state.organisation?.unsubscribe_from_newsletter,
    orchestra_id: state.organisation?.orchestra_id || '',
    logo_progress: 0,
    central_payment: state.organisation?.central_payment || null,
    due_date: state.organisation?.due_date || null,
    due_date_error: '',
    origin_due_date: state.organisation?.origin_due_date || null,

    activated_locales: state.organisation?.activated_locales ?? [],
    contact_emails: state.organisation?.contact_emails ?? [],
    phone_numbers: state.organisation?.phone_numbers ?? [],
    corporate_name_of_agency: state.organisation?.corporate_name_of_agency ?? '',
    Accounting_e_mails: state.organisation?.Accounting_e_mails ?? [],
    preferred_payment_method: state.organisation?.preferred_payment_method ?? PreferredPaymentChoices.TRANSFER,
    billing_method: state.organisation?.billing_method ?? BillingMethod.MANUAL,
});
const toggleGroupPayingReducer = (state: OrganisationState): OrganisationState => ({
    ...state, group_paying: !state.group_paying, group_paying_error: ''
});
const toggleRefreshReducer = (state: OrganisationState): OrganisationState => ({
    ...state, refresh: !state.refresh
});
const updateAddressReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, address: action.payload
});
const updateLatitudeReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, latitude: action.payload
});
const updateLongitudeReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, longitude: action.payload
});
const updateGoogleIdReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, google_id: action.payload
});
const updateZoomReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, zoom: action.payload
});
const updateCountryReducer = (state: OrganisationState, action: PayloadAction<null | IataCountry>): OrganisationState => ({
    ...state, country: action.payload
});

const updateStreetReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, street: action.payload
});
const updateCityReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, city: action.payload
});
const updateBranchCodeReducer = (state: OrganisationState, action: PayloadAction<"fr" | "be">): OrganisationState => ({
    ...state, branch_code: action.payload
});
const updateIsLocationEditOpenReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, is_organisation_location_edit_open: action.payload
});
const updateComplementaryAddressReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, complementary_address: action.payload
});
const updateEmailReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, email: action.payload, email_error: ''
});
const updateExternalIdReducer = (state: OrganisationState, action: PayloadAction<number | string>): OrganisationState => ({
    ...state, external_id: action.payload ?? ''
});
const updateIsBlockedReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, is_blocked: action.payload
});
const updateIsActiveReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, is_active: action.payload
});
const updateInternalNoteReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, internal_note: action.payload
});
const updateUsualNameReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, usual_name: action.payload
});
const updateCommercialsReducer = (state: OrganisationState, action: PayloadAction<Commercial[]>): OrganisationState => ({
    ...state, commercials: action.payload
});
const updateAccountReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, account: action.payload
});
const updateThirdPartyAccountNumberReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, third_party_account_number: action.payload
});
const updateAllowMailingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, allow_mailing: action.payload
});
const updateAllowEmailingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, allow_emailing: action.payload
});

const updateAllowPhoningReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, allow_phoning: action.payload
});

const updateAllowSmsingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, allow_smsing: action.payload
});

const updateUnsubscribeFromNewsletterReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, unsubscribe_from_newsletter: action.payload
});

const updateOrchestraIdReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, orchestra_id: action.payload
});
const updateNameReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, name: action.payload, name_error: ''
});
const updateFilterCreatorReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, filter_creator: action.payload
});
const updateFilterLastAuthorReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, filter_last_author: action.payload, page: 0
});
const updateFilterBrandsReducer = (state: OrganisationState, action: PayloadAction<string[]>): OrganisationState => ({
    ...state, filter_brands: action.payload
});
const updateLogoReducer = (state: OrganisationState, action: PayloadAction<Picture | null>): OrganisationState => ({
    ...state, logo_progress: 0, logo: action.payload
});
const updateLogoProgressReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, logo_progress: action.payload
});
const updateGroupReducer = (state: OrganisationState, action: PayloadAction<Network | GroupMinimal | null>): OrganisationState => ({
    ...state, group: action.payload, group_error: ''
});
const updateSubNetReducer = (state: OrganisationState, action: PayloadAction<Network | null>): OrganisationState => ({
    ...state, sub_net: action.payload, group_error: ''
});
const updateMiniNetworkReducer = (state: OrganisationState, action: PayloadAction<Network | null>): OrganisationState => ({
    ...state, mini_network: action.payload, group_error: ''
});

const updateDomainReducer = (state: OrganisationState, action: PayloadAction<Domain | null>): OrganisationState => ({
    ...state, domain: action.payload
});
const updatePaiementDelayReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state,
    paiement_delay: action.payload,
    paiement_delay_error: ''
});
const updatePhoneNumberReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, phone_number: action.payload, phone_number_error: ''
});
const updatePostalCodeReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, postal_code: action.payload, postal_code_error: ''
});
const updateQuotaReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, quota: action.payload, quota_error: ''
});
const updateSiretReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, siret: action.payload
});
const updateVatNumberReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, vat_number: action.payload
});
const updateTierCodeReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, tier_code: action.payload
});
const addNoteReducer = (state: OrganisationState, action: PayloadAction<OrganisationNote>): OrganisationState => ({
    ...state, notes: [action.payload, ...state.notes]
});
const updateNoteReducer = (state: OrganisationState, action: PayloadAction<OrganisationNote>): OrganisationState => ({
    ...state, notes: state.notes.map((note) => note.id === action.payload.id ? action.payload : note)
});
const updateNotesLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, notes_loading: action.payload
});
const deleteNoteReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, notes: state.notes.filter(note => note.id !== action.payload)
});
const updateNotesReducer = (state: OrganisationState, action: PayloadAction<OrganisationNote[]>): OrganisationState => ({
    ...state, notes: action.payload.map((note) => ({ ...note, is_detailed: false }))
});

const addCommentReducer = (state: OrganisationState, action: PayloadAction<OrganisationComment>): OrganisationState => ({
    ...state, comments: [action.payload, ...state.comments]
});
const updateCommentReducer = (state: OrganisationState, action: PayloadAction<OrganisationComment>): OrganisationState => ({
    ...state, comments: state.comments.map((comment) => comment.id === action.payload.id ? action.payload : comment)
});

const updateCommentsLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, comments_loading: action.payload
});
const deleteCommentReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, comments: state.comments.filter(comment => comment.id !== action.payload)
});
const updateCommentsReducer = (state: OrganisationState, action: PayloadAction<OrganisationComment[]>): OrganisationState => ({
    ...state, comments: action.payload.map((comment) => ({ ...comment, is_detailed: false }))
});

const addContactReducer = (state: OrganisationState, action: PayloadAction<OrganisationContact>): OrganisationState => ({
    ...state, contacts: [action.payload, ...state.contacts]
});

const addContactsCreateReducer = (state: OrganisationState): OrganisationState => ({
    ...state, contacts_create: [...state.contacts_create, { ...EMPTY_ORGANISATION_CONTACT, phone_number_error: '', role_error: '' }]
});
const updateContactsCreateReducer = (state: OrganisationState, action: PayloadAction<{ contact: OrganisationContact & OrganisationContactErrors, index: number }>): OrganisationState => ({
    ...state, contacts_create: state.contacts_create.map((contact, index) => index === action.payload.index ? action.payload.contact : contact)
});
const deleteContactsCreateReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, contacts_create: state.contacts_create.filter((contact, index) => index !== action.payload)
});

const updateContactReducer = (state: OrganisationState, action: PayloadAction<OrganisationContact>): OrganisationState => ({
    ...state, contacts: state.contacts.map((contact) => contact.id === action.payload.id ? action.payload : contact)
});
const deleteContactReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, contacts: state.contacts.filter(contact => contact.id !== action.payload)
});
const updateContactsReducer = (state: OrganisationState, action: PayloadAction<OrganisationContact[]>): OrganisationState => ({
    ...state, contacts: action.payload
});
const updateContactLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, contacts_loading: action.payload
});
const updateDeleteItemReducer = (state: OrganisationState, action: PayloadAction<DeleteItem | null>): OrganisationState => ({
    ...state, delete_item: action.payload
});
const setAccordionRubricsOrderReducer = (state: OrganisationState, action: PayloadAction<OrganisationRubricsItemInterface[]>): OrganisationState => ({
    ...state, rubrics_configuration: { ...state.rubrics_configuration, columns: action.payload }
});
const addOrganisationRubricConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, rubrics_configuration: { ...state.rubrics_configuration, preferences: [...state.rubrics_configuration.preferences, ...action.payload] }
});
const setOrganisationRubricConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, rubrics_configuration: { ...state.rubrics_configuration, preferences: action.payload }
});
const setPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => (console.log(action.payload[0], !!action.payload.find(value => value.module === ORGANISATION_RUBRICS_MODULE)), {
    ...state,
    first_preference_loaded: true,
    rubrics_configuration: action.payload.find(value => value.module === ORGANISATION_RUBRICS_MODULE) ? setOrganisationRubricPreference(action.payload, state.rubrics_configuration.columns) : state.rubrics_configuration,
    trip_list_configuration: action.payload.find(value => value.module === ORGANISATION_TRIP_MODULE) ? setOrganisationTripListPreference(action.payload, state.trip_list_configuration.columns) : state.trip_list_configuration
});
const moveDownTripColumnReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.trip_list_configuration.columns]);
    for (let i = 0; i < columns.length; i++) {
        columns[i].last_updated = false;
    }
    const column = { ...columns[action.payload + 1] };
    columns[action.payload + 1] = columns[action.payload];
    columns[action.payload + 1].last_updated = true;
    columns[action.payload] = column;
    return { ...state, trip_list_configuration: { ...state.trip_list_configuration, columns } };
};

const moveUpTripColumnReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.trip_list_configuration.columns]);
    for (let i = 0; i < columns.length; i++) {
        columns[i].last_updated = false;
    }
    const column = { ...columns[action.payload - 1] };
    columns[action.payload - 1] = columns[action.payload];
    columns[action.payload - 1].last_updated = true;
    columns[action.payload] = column;
    return { ...state, trip_list_configuration: { ...state.trip_list_configuration, columns } };
};
const toggleTripColumnReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => {
    const columns = cloneDeep([...state.trip_list_configuration.columns]);
    const column = { ...columns[action.payload] };
    column.checked = !column.checked;
    columns[action.payload] = column;
    return { ...state, trip_list_configuration: { ...state.trip_list_configuration, columns } };
};
const updateTripListReducer = (state: OrganisationState, action: PayloadAction<Trip[]>): OrganisationState => ({
    ...state, trip_list: action.payload
});
const setEmailLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, email_loading: action.payload
});
const setHistTripsReducer = (state: OrganisationState, action: PayloadAction<OrganisationHistTrip[]>): OrganisationState => ({
    ...state, hist_trips: action.payload, hist_trips_loading: false
});
const setHistTripsLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, hist_trips_loading: action.payload
});
const updateTripListCriteriaReducer = (state: OrganisationState, action: PayloadAction<OrganisationTripListCriteria>): OrganisationState => ({
    ...state, trip_list_criteria: action.payload
});
const updateTripListLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, trip_list_loading: action.payload
});
const updateTripListCountReducer = (state: OrganisationState, action: PayloadAction<number>): OrganisationState => ({
    ...state, trip_list_count: action.payload
});
const addTripListConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, trip_list_configuration: { ...state.trip_list_configuration, preferences: [...state.trip_list_configuration.preferences, ...action.payload] }
});
const setTripListConfigurationPreferenceReducer = (state: OrganisationState, action: PayloadAction<Preferences[]>): OrganisationState => ({
    ...state, trip_list_configuration: { ...state.trip_list_configuration, preferences: action.payload }
});
const updateCentralPaymentReducer = (state: OrganisationState, action: PayloadAction<null | CentralPayment>): OrganisationState => ({
    ...state, central_payment: action.payload
});
const updateDueDateReducer = (state: OrganisationState, action: PayloadAction<null | Settlement>): OrganisationState => ({
    ...state, due_date: action.payload, due_date_error: ''
});
const addEmailHistoryReducer = (state: OrganisationState, action: PayloadAction<MailHistory>): OrganisationState => ({
    ...state, email_history: [action.payload, ...state.email_history]
});
const setEmailhistoryReducer = (state: OrganisationState, action: PayloadAction<MailHistory[]>): OrganisationState => ({
    ...state, email_history: action.payload, email_history_loading: false
});
const setEmailHistoryLoadingReducer = (state: OrganisationState, action: PayloadAction<boolean>): OrganisationState => ({
    ...state, email_history_loading: action.payload
});
const setInvoiceCredentialReducer = (state: OrganisationState, action: PayloadAction<{ trip: Trip, invoice: OrganisationInvoice } | null>) => ({
    ...state, invoice_credential: action.payload
});

const setInvoiceListReducer = (state: OrganisationState, action: PayloadAction<OrganisationInvoice[] | null>): OrganisationState => ({
    ...state, invoice_list: action.payload, trip_open_id: action.payload ? state.trip_open_id : null
});
const updateInvoiceReducer = (state: OrganisationState, action: PayloadAction<OrganisationInvoice>): OrganisationState => ({
    ...state, invoice_list: state.invoice_list?.map((invoice) => invoice.id === action.payload.id ? action.payload : invoice) || null
});
const setTripOpenIdReducer = (state: OrganisationState, action: PayloadAction<number | null>): OrganisationState => ({
    ...state, trip_open_id: action.payload
});
const setBrandReducer = (state: OrganisationState, action: PayloadAction<string[]>): OrganisationState => ({
    ...state, brands: action.payload
});
const resetFiltersReducer = (state: OrganisationState): OrganisationState => ({
    ...state, ...EMPTY_ORGANISATION_FILTERS
});
const updateFilterVatNumberReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, filter_vat_number: action.payload
});
const updateFilterCityReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, filter_city: action.payload
});
const updateFilterExternalIdReducer = (state: OrganisationState, action: PayloadAction<string>): OrganisationState => ({
    ...state, filter_external_id: action.payload
});
const updateFilterCommercialsReducer = (state: OrganisationState, action: PayloadAction<Commercial[]>): OrganisationState => ({
    ...state, filter_commercials: action.payload
});


export const organisation = createSlice({
    name: 'organisation',
    initialState,
    reducers: {
        refreshMarginList: refreshMarginListReducer,
        setSuspendedMargin: setSuspendedMarginReducer,
        addMarginsConfigurationPreference: addMarginsConfigurationPreferenceReducer,
        setMarginsConfigurationPreference: setMarginsConfigurationPreferenceReducer,
        moveDownColumnMargins: moveDownColumnMarginsReducer,
        moveUpColumnMargins: moveUpColumnMarginsReducer,
        toggleColumnMargins: toggleColumnMarginsReducer,
        setOrganisationMargins: setNetworkMarginsReducer,
        updateMarginsCriteria: updateMarginsCriteriaReducer,
        updateMargin: updateMarginReducer,
        updateMarginsLoading: updateMarginsLoadingReducer,
        updateMarginsCount: updateMarginsCountReducer,
        setRevisionHistory: setRevisionHistoryReducer,
        setColumns: setColumnsReducer,
        resetOrganisation: resetOrganisationReducer,
        resteProfilLogo: resteProfilLogoReducer,
        setDeleteOrganisation: setDeleteOrganisationReducer,
        setEditStep: setEditStepReducer,
        setEditingField: setEditingFieldReducer,
        setError: setErrorReducer,
        setErrors: setErrorsReducer,
        setExportType: setExportTypeReducer,
        setLimit: setLimitReducer,
        setList: setListReducer,
        setLogoError: setLogoErrorReducer,
        setOrderBy: setOrderByReducer,
        setPage: setPageReducer,
        setRunning: setRunningReducer,
        setSearch: setSearchReducer,
        setOrganisation: setOrganisationReducer,
        setType: setTypeReducer,
        toggleColumn: toggleColumnReducer,
        toggleAllowMargin: toggleAllowMarginReducer,
        toggleCreate: toggleCreateReducer,
        toggleExport: toggleExportReducer,
        toggleExportFull: toggleExportFullReducer,
        toggleFilters: toggleFiltersReducer,
        toggleEditInfo: toggleEditInfoReducer,
        toggleGroupPaying: toggleGroupPayingReducer,
        toggleRefresh: toggleRefreshReducer,
        updateAddress: updateAddressReducer,
        updateLatitude: updateLatitudeReducer,
        updateLongitude: updateLongitudeReducer,
        updateGoogleId: updateGoogleIdReducer,
        updateZoom: updateZoomReducer,
        updateCity: updateCityReducer,
        updateBranchCode: updateBranchCodeReducer,
        updateIsLocationEditOpen: updateIsLocationEditOpenReducer,
        updateCountry: updateCountryReducer,
        updateStreet: updateStreetReducer,
        updateComplementaryAddress: updateComplementaryAddressReducer,
        updateEmail: updateEmailReducer,
        updateIsBlocked: updateIsBlockedReducer,
        updateIsActive: updateIsActiveReducer,
        updateInternalNote: updateInternalNoteReducer,
        updateExternalId: updateExternalIdReducer,
        updateUsualName: updateUsualNameReducer,
        updateCommercials: updateCommercialsReducer,
        updateAccount: updateAccountReducer,
        updateThirdPartyAccountNumber: updateThirdPartyAccountNumberReducer,
        updateAllowMailing: updateAllowMailingReducer,
        updateAllowEmailing: updateAllowEmailingReducer,
        updateAllowPhoning: updateAllowPhoningReducer,
        updateAllowSmsing: updateAllowSmsingReducer,
        updateUnsubscribeFromNewsletter: updateUnsubscribeFromNewsletterReducer,
        updateOrchestraId: updateOrchestraIdReducer,
        updateName: updateNameReducer,
        updateFilterCreator: updateFilterCreatorReducer,
        updateFilterLastAuthor: updateFilterLastAuthorReducer,
        updateFilterBrands: updateFilterBrandsReducer,
        updateLogo: updateLogoReducer,
        updateLogoProgress: updateLogoProgressReducer,
        updateGroup: updateGroupReducer,
        updateSubNet: updateSubNetReducer,
        updateMiniNetwork: updateMiniNetworkReducer,
        updateDomain: updateDomainReducer,
        updatePaiementDelay: updatePaiementDelayReducer,
        updatePhoneNumber: updatePhoneNumberReducer,
        updatePostalCode: updatePostalCodeReducer,
        updateQuota: updateQuotaReducer,
        updateSiret: updateSiretReducer,
        updateVatNumber: updateVatNumberReducer,
        updateTierCode: updateTierCodeReducer,
        addNote: addNoteReducer,
        updateNote: updateNoteReducer,
        updateNotesLoading: updateNotesLoadingReducer,
        deleteNote: deleteNoteReducer,
        updateNotes: updateNotesReducer,
        addComment: addCommentReducer,
        updateComment: updateCommentReducer,
        updateCommentsLoading: updateCommentsLoadingReducer,
        deleteComment: deleteCommentReducer,
        updateComments: updateCommentsReducer,
        addContact: addContactReducer,
        updateContact: updateContactReducer,
        deleteContact: deleteContactReducer,
        addContactsCreate: addContactsCreateReducer,
        updateContactsCreate: updateContactsCreateReducer,
        deleteContactsCreate: deleteContactsCreateReducer,
        updateContacts: updateContactsReducer,
        updateContactLoading: updateContactLoadingReducer,
        updateDeleteItem: updateDeleteItemReducer,
        setAccordionRubricsOrder: setAccordionRubricsOrderReducer,
        addOrganisationRubricConfigurationPreference: addOrganisationRubricConfigurationPreferenceReducer,
        setOrganisationRubricConfigurationPreference: setOrganisationRubricConfigurationPreferenceReducer,
        setHistTripsLoading: setHistTripsLoadingReducer,
        setHistTrips: setHistTripsReducer,
        setEmailLoading: setEmailLoadingReducer,
        moveDownTripColumn: moveDownTripColumnReducer,
        moveUpTripColumn: moveUpTripColumnReducer,
        toggleTripColumn: toggleTripColumnReducer,
        updateTripList: updateTripListReducer,
        updateTripListCriteria: updateTripListCriteriaReducer,
        updateTripListLoading: updateTripListLoadingReducer,
        updateTripListCount: updateTripListCountReducer,
        addTripListConfigurationPreference: addTripListConfigurationPreferenceReducer,
        setTripListConfigurationPreference: setTripListConfigurationPreferenceReducer,
        updateCentralPayment: updateCentralPaymentReducer,
        updateDueDate: updateDueDateReducer,
        setInvoiceCredential: setInvoiceCredentialReducer,
        setInvoiceList: setInvoiceListReducer,
        updateInvoice: updateInvoiceReducer,
        setTripOpenId: setTripOpenIdReducer,
        addEmailHistory: addEmailHistoryReducer,
        setEmailhistory: setEmailhistoryReducer,
        setEmailHistoryLoading: setEmailHistoryLoadingReducer,
        setActivatedLocales: setActivatedLocalesReducer,
        addContactEmails: addContactEmailsReducer,
        setContactEmails: setContactEmailsReducer,
        deleteContactEmails: deleteContactEmailsReducer,
        addAccountingEmails: addAccountingEmailsReducer,
        setAccountingEmails: setAccountingEmailsReducer,
        deleteAccountingEmails: deleteAccountingEmailsReducer,
        addPhoneNumbers: addPhoneNumbersReducer,
        setPhoneNumbers: setPhoneNumbersReducer,
        deletePhoneNumbers: deletePhoneNumbersReducer,
        setCorporateNameOfAgency: setCorporateNameOfAgencyReducer,
        setPreferredPaymentMethod: setPreferredPaymentMethodReducer,
        setBillingMethod: setBillingMethodReducer,
        setTripColumns: setTripColumnsReducer,
        setBrand: setBrandReducer,
        resetFilters: resetFiltersReducer,
        updateFilterVatNumber: updateFilterVatNumberReducer,
        updateFilterExternalId: updateFilterExternalIdReducer,
        updateFilterCity: updateFilterCityReducer,
        updateFilterCommercials: updateFilterCommercialsReducer,
    },
    extraReducers: (builder) => {
        builder
            .addCase(setPreferences, setPreferenceReducer);
    }
});

export const {
    refreshMarginList,
    setSuspendedMargin,
    addMarginsConfigurationPreference,
    setMarginsConfigurationPreference,
    moveDownColumnMargins,
    moveUpColumnMargins,
    toggleColumnMargins,
    setOrganisationMargins,
    updateMarginsCriteria,
    updateMargin,
    updateMarginsLoading,
    updateMarginsCount,
    setRevisionHistory,
    setColumns,
    resetOrganisation,
    resteProfilLogo,
    setDeleteOrganisation,
    setEditStep,
    setEditingField,
    setError,
    setErrors,
    setExportType,
    setLimit,
    setList,
    setLogoError,
    setOrderBy,
    setPage,
    setRunning,
    setSearch,
    setOrganisation,
    setType,
    toggleColumn,
    toggleCreate,
    toggleAllowMargin,
    toggleExport,
    toggleExportFull,
    toggleFilters,
    toggleEditInfo,
    toggleGroupPaying,
    toggleRefresh,
    updateAddress,
    updateLatitude,
    updateLongitude,
    updateGoogleId,
    updateZoom,
    updateCity,
    updateBranchCode,
    updateIsLocationEditOpen,
    updateCountry,
    updateStreet,
    updateComplementaryAddress,
    updateEmail,
    updateExternalId,
    updateIsBlocked,
    updateIsActive,
    updateInternalNote,
    updateUsualName,
    updateCommercials,
    updateAccount,
    updateAllowEmailing,
    updateAllowMailing,
    updateAllowPhoning,
    updateAllowSmsing,
    updateUnsubscribeFromNewsletter,
    updateOrchestraId,
    updateName,
    updateFilterCreator,
    updateFilterLastAuthor,
    updateFilterBrands,
    updateLogo,
    updateLogoProgress,
    updateGroup,
    updateSubNet,
    updateMiniNetwork,
    updateDomain,
    updatePaiementDelay,
    updatePhoneNumber,
    updatePostalCode,
    updateQuota,
    updateSiret,
    updateVatNumber,
    updateTierCode,
    updateNotes,
    addNote,
    updateNote,
    updateNotesLoading,
    deleteNote,
    updateComments,
    addComment,
    updateComment,
    updateCommentsLoading,
    deleteComment,
    updateContacts,
    addContact,
    updateContact,
    deleteContact,
    addContactsCreate,
    updateContactsCreate,
    deleteContactsCreate,
    updateContactLoading,
    updateDeleteItem,
    setAccordionRubricsOrder,
    addOrganisationRubricConfigurationPreference,
    setOrganisationRubricConfigurationPreference,
    setHistTripsLoading,
    setHistTrips,
    setEmailLoading,
    moveDownTripColumn,
    moveUpTripColumn,
    toggleTripColumn,
    updateTripList,
    updateTripListCriteria,
    updateTripListLoading,
    updateTripListCount,
    addTripListConfigurationPreference,
    setTripListConfigurationPreference,
    updateCentralPayment,
    updateDueDate,
    setInvoiceCredential,
    setInvoiceList,
    updateInvoice,
    setTripOpenId,
    addEmailHistory,
    setEmailhistory,
    setEmailHistoryLoading,
    setActivatedLocales,
    addContactEmails,
    setContactEmails,
    deleteContactEmails,
    addAccountingEmails,
    setAccountingEmails,
    deleteAccountingEmails,
    addPhoneNumbers,
    setPhoneNumbers,
    deletePhoneNumbers,
    setCorporateNameOfAgency,
    setPreferredPaymentMethod,
    setBillingMethod,
    updateThirdPartyAccountNumber,
    setTripColumns,
    setBrand,
    resetFilters,
    updateFilterVatNumber,
    updateFilterExternalId,
    updateFilterCity,
    updateFilterCommercials,
} = organisation.actions;